import { useEffect, useState } from 'react'
import { apiGet } from './primitives.js'
import { humanName } from '../rh/format.js'

/**
 * SHADOW MODE (§104) — comparaison temporaire Gestion Pointeuse vs Skello
 * pendant la migration. Diagnostic technique : Skello reste READ-ONLY et
 * source legacy ; aucun import automatique de staff_punch dans clock_event
 * (§105) — les deux historiques restent distincts.
 */
export function ShadowClockSection() {
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10))
  const [data, setData] = useState<{
    gestion: Array<{ person_id: string; display_name: string; kind: string; device_time: string }>
    skello: Array<{ person_id: string | null; display_name: string | null; started_at: string; ended_at: string | null; auto_closed: boolean }>
  } | null>(null)
  useEffect(() => {
    apiGet<NonNullable<typeof data> & { date: string }>(`/api/v1/hr/time/shadow-skello?date=${date}`)
      .then(setData).catch(() => setData({ gestion: [], skello: [] }))
  }, [date])
  const hm = (iso: string) => new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' })
  return (
    <section className="lc-card tv-block">
      <div className="tv-credrow">
        <label className="lc-hint" htmlFor="shadow-date">Journée :</label>
        <input id="shadow-date" type="date" className="lc-input" value={date} onChange={(e) => setDate(e.target.value)} />
      </div>
      <p className="lc-hint">Comparaison de migration : Gestion Pointeuse (canonique) face à la badgeuse Skello (legacy, lecture seule). Aucun import : les deux historiques restent distincts.</p>
      {!data ? <p className="lc-hint">Chargement…</p> : (
        <div className="rh-match__cols" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="rh-match__col">
            <span className="rh-match__source">Gestion Pointeuse</span>
            {data.gestion.length === 0 ? <p className="lc-hint">Aucun pointage Gestion.</p>
              : data.gestion.map((e, i) => (
                <p key={i} className="lc-hint" style={{ margin: 0 }}>
                  {humanName(e.display_name)} — {e.kind === 'IN' ? 'entrée' : 'sortie'} {hm(e.device_time)}
                </p>
              ))}
          </div>
          <div className="rh-match__col">
            <span className="rh-match__source">Skello (legacy)</span>
            {data.skello.length === 0 ? <p className="lc-hint">Aucun pointage Skello.</p>
              : data.skello.map((e, i) => (
                <p key={i} className="lc-hint" style={{ margin: 0 }}>
                  {e.display_name ? humanName(e.display_name) : 'Identité non rapprochée'} — {hm(e.started_at)} → {e.ended_at ? hm(e.ended_at) : 'ouvert'}{e.auto_closed ? ' (auto-clôturé)' : ''}
                </p>
              ))}
          </div>
        </div>
      )}
    </section>
  )
}
